import { ClaimDTO, GetPublicClaimDetailResponse } from "../../client/motalvip-apis/generated";

export const LockTypeNameMapping = {
    [GetPublicClaimDetailResponse.lockType.NONE]: 'ไม่มี',
    [GetPublicClaimDetailResponse.lockType.PIN]: 'PIN',
    [GetPublicClaimDetailResponse.lockType.PASSWORD]: 'รหัสผ่าน',
    [GetPublicClaimDetailResponse.lockType.PATTERN]: 'รูปแบบ',
}

export const ClaimStatusNameMapping: Record<ClaimDTO.status, string> = {
    [ClaimDTO.status.RECEIVE]: "รับเคส",
    [ClaimDTO.status.ORDER_SPARE]: "สั่งอะไหล่",
    [ClaimDTO.status.RECEIVE_SPARE]: "ได้รับอะไหล่",
    [ClaimDTO.status.REPAIRING]: "กำลังซ่อม",
    [ClaimDTO.status.TESTING]: "ทดสอบ",
    [ClaimDTO.status.REPAIR_SUCCESS]: "ซ่อมเสร็จ",
    [ClaimDTO.status.REPAIR_FAIL]: "ซ่อมไม่สำเร็จ",
    [ClaimDTO.status.CANCEL]: "ยกเลิก",
    [ClaimDTO.status.NONE]: "ไม่ระบุ",
} as const

export const ClaimStatusDescriptionMapping: Record<ClaimDTO.status, string> = {
    [ClaimDTO.status.RECEIVE]: "ทางร้านได้รับเคสแล้ว",
    [ClaimDTO.status.ORDER_SPARE]: "ทางร้านได้สั่งอะไหล่สำหรับซ่อมแล้ว",
    [ClaimDTO.status.RECEIVE_SPARE]: "ทางร้านได้รับอะไหล่แล้ว",
    [ClaimDTO.status.REPAIRING]: "ทางร้านกำลังซ่อมสินค้าให้คุณ",
    [ClaimDTO.status.TESTING]: "ทางร้านกำลังทดสอบสินค้า",
    [ClaimDTO.status.REPAIR_SUCCESS]: "ทางร้านซ่อมสินค้าได้เสร็จสิ้น",
    [ClaimDTO.status.REPAIR_FAIL]: "ทางร้านซ่อมสินค้าไม่สำเร็จ",
    [ClaimDTO.status.CANCEL]: "ทางร้านยกเลิกการซ่อมสินค้า",
    [ClaimDTO.status.NONE]: "ไม่ระบุ",
}

export const ClaimStatusColorMapping: Record<ClaimDTO.status, string> = {
    [ClaimDTO.status.RECEIVE]: "#334046",
    [ClaimDTO.status.ORDER_SPARE]: "#00A1E1",
    [ClaimDTO.status.RECEIVE_SPARE]: "#00A1E1",
    [ClaimDTO.status.REPAIRING]: "#156BFF",
    [ClaimDTO.status.TESTING]: "#E8BB06",
    [ClaimDTO.status.REPAIR_SUCCESS]: "#159B4F",
    [ClaimDTO.status.REPAIR_FAIL]: "#E8BB06",
    [ClaimDTO.status.CANCEL]: "#E83323",
    [ClaimDTO.status.NONE]: "#292929",
} as const